import http from '@/http'
import apiUrl from '@/config'

const state = {
  reasons: [],
  statuses: [],
  states: []
}

const getters = {
  getReasons: (state) => {
    return state.reasons
  },
  getStatuses: (state) => {
    return state.statuses
  },
  getStates: (state) => {
    return state.states
  }
}

const mutations = {
  SET_REASONS (state, data) {
    state.reasons = data.reasons
  },
  SET_STATUSES (state, data) {
    state.statuses = data.statuses
  },
  SET_STATES (state, data) {
    state.states = data.states
  }
}

const actions = {
  checkReasons ({ commit, state }, payload) {
    if (state.reasons.length > 0) return Promise.resolve()

    return http.post(apiUrl.return_reason_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_REASONS', { reasons: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkReasons:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkStatuses ({ commit, state }, payload) {
    if (state.statuses.length > 0) return Promise.resolve()

    return http.post(apiUrl.return_process_status_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_STATUSES', { statuses: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkStatuses:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkStates ({ commit, state }, payload) {
    if (state.states.length > 0) return Promise.resolve()

    return http.post(apiUrl.return_states_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_STATES', { states: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkStates:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
